<template>
    <div>Wkrótce</div>
</template>

<script>
export default {};
</script>

<style>

</style>